/*
 * Bricktopia — product card price tweaks
 * ------------------------------------------------
 *  - Strips trailing ".00" and ",00" from prices inside product cards
 *    (product pages and other contexts are NOT affected)
 *  - Compare-at-price layout is handled via CSS (flex order)
 * ------------------------------------------------
 */
(function () {
  var STRIP_RE = /([.,])00(?=\D|$)/g;
  var SEL = '.product-card .price, .product-card .compare-at-price, .product-card s';

  function strip(el) {
    if (el.dataset.btStripped === '1') return;
    var orig = el.textContent;
    var next = orig.replace(STRIP_RE, '');
    if (orig !== next) el.textContent = next;
    el.dataset.btStripped = '1';
  }

  function run(root) {
    root = root || document;
    var nodes = (root.querySelectorAll || document.querySelectorAll).call(root, SEL);
    for (var i = 0; i < nodes.length; i++) strip(nodes[i]);
  }

  function init() {
    run(document);
    // Observe for dynamically-added cards (variant switch, ajax collections)
    var observer = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && (n.matches('.product-card') || n.querySelector('.product-card'))) {
            run(n);
          } else if (n.closest && n.closest('.product-card')) {
            run(n.closest('.product-card'));
          }
        }
        if (m.type === 'characterData' && m.target.parentElement) {
          var parent = m.target.parentElement;
          if (parent.closest && parent.closest('.product-card')) {
            delete parent.dataset.btStripped;
            run(parent.closest('.product-card'));
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
